import React from "react";
import { CheckCircle2 } from "lucide-react";
import { siteContent } from "../content/siteContent";

const WhyChoose = () => {
  const { kicker, title, image, stats, highlights } = siteContent.whyChoose;
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        {/* Image */}
        <div className="relative order-2 lg:order-1">
          <div className="rounded-xl overflow-hidden shadow-2xl">
            <img src={image} alt="Why choose us" className="w-full h-[480px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-[#22b8db] text-white rounded-lg p-5 shadow-xl hidden md:block">
            <div className="text-3xl font-extrabold">100+</div>
            <div className="text-white/90 text-sm font-medium">Trusted Clients</div>
          </div>
        </div>

        {/* Text */}
        <div className="order-1 lg:order-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-16 h-px bg-[#22b8db]" />
            <div className="text-[#22b8db] font-semibold tracking-widest uppercase text-xs">
              {kicker}
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1a3a6e] mb-6 leading-tight">
            {title}
          </h2>
          <p className="text-slate-500 leading-relaxed mb-8">
            We combine deep RCM expertise with technology-enabled workflows to help
            healthcare providers accelerate collections, reduce denials and improve
            patient experience — all under strict compliance.
          </p>

          <div className="grid grid-cols-2 gap-5 mb-8">
            {stats.map((s) => (
              <div key={s.label} className="bg-slate-50 rounded-lg p-5 border border-slate-100">
                <div className="text-3xl font-extrabold text-[#22b8db]">{s.value}</div>
                <div className="text-slate-500 text-sm font-medium mt-1">{s.label}</div>
              </div>
            ))}
          </div>

          <ul className="space-y-3">
            {highlights.map((h) => (
              <li key={h} className="flex items-center gap-3 text-slate-600">
                <CheckCircle2 className="w-5 h-5 text-[#22b8db] flex-shrink-0" />
                <span className="text-[15px]">{h}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
